module.exports = __webpack_public_path__ + "img/car_darkgrey.79f55e45.png";